import { render } from "./upAction.vue?vue&type=template&id=508f096f&scoped=true"
import script from "./upAction.vue?vue&type=script&lang=js"
export * from "./upAction.vue?vue&type=script&lang=js"

import "./upAction.vue?vue&type=style&index=0&id=508f096f&scoped=true&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508f096f"]])

export default __exports__